import React from 'react';

type Props = { onClose?: () => void };

export function EasterEggMatrix({ onClose }: Props) {
  return (
    <div
      role="region"
      aria-label="Matrix playground"
      className="mt-6 rounded-xl border bg-card text-card-foreground shadow-sm p-4 md:p-6"
    >
      <div className="flex items-center justify-between gap-4">
        <div>
          <h3 className="text-base md:text-lg font-semibold">Matrix playground</h3>
          <p className="text-sm text-muted-foreground">
            A tiny treat from the team—press Space ×3 to toggle.
          </p>
        </div>
        {onClose ? (
          <button
            className="text-xs px-2 py-1 rounded border hover:bg-accent"
            onClick={onClose}
          >
            Hide
          </button>
        ) : null}
      </div>

      <a
        href="https://ui.elevenlabs.io/view/pong-01"
        target="_blank"
        rel="noreferrer"
        className="block mt-4"
        aria-label="Open ElevenLabs matrix demo in a new tab"
      >
        <img
          src="/assets/easter/matrix.png"
          alt="Open ElevenLabs matrix demo"
          className="w-full rounded-lg border"
        />
      </a>

      <pre className="mt-3 inline-block rounded bg-muted px-2 py-1 text-xs">
        npx shadcn@latest add @elevenlabs-ui/matrix
      </pre>
    </div>
  );
}